export const enhancer = el => {
  el.setAttribute('aria-hidden', 'true');

  const toggle = e => {
    e.preventDefault();
    el.setAttribute('aria-hidden', el.getAttribute('aria-hidden') === 'false');
  };

  const openButton = document.querySelector(`[aria-controls="${el.id}"]`);
  openButton.addEventListener('click', toggle);

  const closeButton = el.querySelector(`.js-close`);
  closeButton.addEventListener('click', toggle);
};
